import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { extendObservable } from 'mobx'
import PropTypes from 'prop-types'
import Checkbox from '@components/Checkbox'
import InfoBox from '@components/InfoBox'
import Select from '@components/Select'
import Spinner from '@components/spinner'
import Tooltip from '@components/Tooltip'
import CloseIcon from '@components/Icon/SmallCross.js'
import FasterScheduling from '@atheneum/faster-scheduling'
import AvailabilityStore from '@atheneum/faster-scheduling/dist/stores/Availability.store'
import { submitSchedule } from '@atheneum/faster-scheduling/dist/api'

import { capi, projectApi } from '@atheneum/api'

const inputExpertMobilePhoneStyle = {
  marginBottom: '5px',
  marginLeft: ' 6px'
}

class ScheduleCalendarModal extends Component {
  constructor(props) {
    super(props)
    const { staticData, epl, userStore, project } = this.props

    extendObservable(this, {
      availabilityStore: new AvailabilityStore({
        staticData,
        epl,
        userStore,
        project
      })
    })
    this.availabilityStore.init()

    this.state = {
      metricSend: false
    }

    this.capiSendExpertAvailabilities = this.capiSendExpertAvailabilities.bind(this)
  }

  sendSmsIsChecked = phoneId =>
    Boolean(
      this.availabilityStore.sendSmsToPhoneNumberIds.find(id => phoneId === id)
    )

  validatePhoneNumbersFormat = () => {
    if (!this.availabilityStore.sendSmsReminders) return true

    let phoneNumbersHasErrors = false

    const checkPhoneNumberFormat = /^\+[1-9]{1}[0-9]{3,14}$/

    const expertPhoneNumbers = this.availabilityStore.expertPhoneNumbers.map(
      phone => {
        if (
          this.sendSmsIsChecked(phone.id) &&
          !checkPhoneNumberFormat.test(phone.phoneNum)
        ) {
          phone.hasError = true
          phoneNumbersHasErrors = true
        } else {
          phone.hasError = false
        }

        return phone
      }
    )

    this.availabilityStore.expertPhoneNumbers.replace(expertPhoneNumbers)

    return !phoneNumbersHasErrors
  }

  handleSubmit = async () => {
    if (
      this.availabilityStore.submitting ||
      !this.validatePhoneNumbersFormat()
    ) {
      return
    }

    this.availabilityStore
      .saveSchedule()
      .catch(error => {
        if (error.message === 'Slot is already taken for this expert.') {
          this.availabilityStore.schedule = null
        }
        console.error(error)
        this.props.growlStore.showError(
          error,
          error.message || `Error: Couldn't save your changes!`
        )
      })
      .then(() => {
        this.availabilityStore.submitting = false
        this.availabilityStore.init()
        this.props.eplModel.get()
      })
  }

  handleClose = () => {
    this.props.eplModel.get()
    this.props.modalStore.close()
  }

  showZoomMeetingModal = async ({ openModalOnClose }) => {
    const { modalStore } = this.props
    const { epl } = modalStore.props
    const { persistedScheduleInfo } = this.availabilityStore
    const existing = persistedScheduleInfo.zoomMeeting
      ? []
      : await projectApi.getZoomMeetings(epl.projectId, persistedScheduleInfo.startTime)

    return modalStore.show({
      type: 'ZOOM_MEETING_MODAL',
      props: {
        epl: epl,
        eplModel: this.props.eplModel,
        matchedZoomMeetings: existing,
        schedule: persistedScheduleInfo,
        openModalOnClose: openModalOnClose,
        closeAfter: !!openModalOnClose || true,
        project: this.props.project
      }
    })
  }

  showInviteExpert = () => {
    const { modalStore, project } = this.props
    const { epl } = modalStore.props
    const { persistedScheduleInfo } = this.availabilityStore

    if (!persistedScheduleInfo.zoomMeeting) {
      return this.showZoomMeetingModal({
        openModalOnClose: 'INVITE_EXPERT'
      })
    }

    return modalStore.show({
      type: 'INVITE_EXPERT',
      props: {
        epl: epl,
        eplModel: this.props.eplModel,
        schedule: persistedScheduleInfo,
        closeAfter: true,
        project: project
      }
    })
  }

  showInviteClient = () => {
    const { modalStore, project } = this.props
    const { epl } = modalStore.props
    const { persistedScheduleInfo } = this.availabilityStore

    if (!persistedScheduleInfo.zoomMeeting) {
      return this.showZoomMeetingModal({
        openModalOnClose: 'INVITE_CLIENT'
      })
    }

    return modalStore.show({
      type: 'INVITE_CLIENT',
      props: {
        epl,
        eplModel: this.props.eplModel,
        schedule: persistedScheduleInfo,
        closeAfter: true,
        project
      }
    })
  }

  renderLoader = () => {
    if (!this.availabilityStore.isLoading) return null

    return (
      <div className='spinner__modal-container'>
        <Spinner />
      </div>
    )
  }

  renderTimezoneAndInterviewDuration = () => {
    const interviewDurationInput = (
      <div>
        <Select
          blue
          value={this.availabilityStore.interviewDuration}
          options={this.availabilityStore.interviewDurationOptions}
          onChange={this.availabilityStore.changeInterviewDuration}
          disabled={this.availabilityStore.isInterviewDurationLocked}
        />
      </div>
    )

    return (
      <div className='request-schedule__section m-t-xl m-b-xl'>
        <div className='request-schedule__timezone'>
          <label htmlFor=''>Timezone</label>
          <Select
            blue
            value={this.availabilityStore.timezone}
            options={this.availabilityStore.timezoneOptions}
            onChange={this.availabilityStore.changeTimezone}
          />
        </div>

        <div className='request-schedule__interview-duration'>
          <label htmlFor=''>Interview duration</label>
          {this.availabilityStore.isInterviewDurationLocked ? (
            <Tooltip tooltip='You cannot make changes to the duration of the interview, because it is already Scheduled for a set duration.'>
              {interviewDurationInput}
            </Tooltip>
          ) : (
            interviewDurationInput
          )}
        </div>

        <div className='request-schedule__lock-duration'>
          <Checkbox
            onChange={this.availabilityStore.changeLockInterviewDuration}
            value={this.availabilityStore.lockInterviewDuration}
            label='Lock duration for clients'
            tooltip='This will prevent clients from changing the interview duration.'
          />
        </div>
      </div>
    )
  }

  onChangeSendSms(checked, phone) {
    const phoneId = phone.id
    const phoneNumberIds = this.availabilityStore.sendSmsToPhoneNumberIds

    if (checked) {
      phoneNumberIds.push(phoneId)
    } else {
      const index = phoneNumberIds.indexOf(phoneId)
      if (index > -1) {
        phoneNumberIds.splice(index, 1)
      }
    }
  }

  renderPhoneNumbers = () => {
    if (!this.availabilityStore.sendSmsReminders) return null

    return (
      <>
        <h2 className='expert-profile__subtitle schedule-calendar__subtitle'>
          Expert mobile phones
          <Tooltip
            tooltip={this.availabilityStore.staticData.phoneNumberTooltipText}
          />
        </h2>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '20px'
          }}
        >
          {this.availabilityStore.expertHasNumber && (
            <div className='flex-center'>
              <Checkbox
                onChange={e =>
                  (this.availabilityStore.sendSmsExpertPhoneNumber = Boolean(e))
                }
                value={this.availabilityStore.sendSmsExpertPhoneNumber}
                label='Send SMS'
              />
              <input
                style={inputExpertMobilePhoneStyle}
                value={this.availabilityStore.expertPhoneNum}
                disabled
              />
              <Tooltip tooltip='Mobile phone added by expert' />
            </div>
          )}
          {this.availabilityStore.expertPhoneNumbers.length > 0 &&
            this.availabilityStore.expertPhoneNumbers.map((phone, index) => {
              return (
                <>
                  <div className='flex-center'>
                    <Checkbox
                      onChange={e => this.onChangeSendSms(e, phone)}
                      value={this.sendSmsIsChecked(phone.id)}
                      label='Send SMS'
                    />
                    <input
                      style={inputExpertMobilePhoneStyle}
                      onChange={e => (phone.phoneNum = e.target.value)}
                      value={phone.phoneNum}
                      key={index}
                      placeholder='Mobile phone...'
                    />
                  </div>
                  {phone.hasError && (
                    <div className='schedule-calendar-modal__input-error'>
                      Phone number must contain only digits, '+' sign and max
                      length of 16 chars
                    </div>
                  )}
                </>
              )
            })}
        </div>

        <InfoBox icon={null}>
          Reminders will be sent automatically if a number is entered and
          compliance is in place
        </InfoBox>
      </>
    )
  }

  capiSendExpertAvailabilities = async (availabilities) => {
    const convertTimeSlot = (time) => {
      // Send timestamp as is
      return `${time.start} - ${time.end}`
    }

    const { epl } = this.props
    const expertAvailabilities = availabilities
      .filter(availability => availability.type === 'expert')
      .map(expertAvailability => convertTimeSlot(expertAvailability.time))

    if (!expertAvailabilities.length) {
      return
    }

    try {
      await capi.provideAvailabilities({
        expertAvailabilities,
        requestedDuration: this.availabilityStore.interviewDuration,
        eplId: epl.id,
      })
    } catch (error) {
      this.props.growlStore.showError(
        error,
        `Error: Couldn't submit expert availabilities`
      )
    }

    return expertAvailabilities
  }

  sendToCalendarService = async (schedule, multipleExperts) => {
    try {
      if (multipleExperts) {
        return multipleExperts.forEach(async (expert, i) => {
          this.props.growlStore.showSuccess(`Updating schedule... [${i + 1}/${multipleExperts.length}]`)

          await submitSchedule({
            availabilities: schedule.availabilities,
            drafts: [],
            timeslots: schedule.timeslots,
            eplId: expert.epl.id,
            lockInterviewDuration: false,
            sendSmsToPhoneNumberIds: [],
            expertPhoneNumbers: [],
            sendSmsExpertPhoneNumber: null,
            message: {
              subjectExpert: '',
              subjectClient: '',
              expertEmail: '',
              clientMail: ''
            }
          })

          await expert.get()
          this.props.growlStore.showSuccess(`Schedule Updated [${i + 1}/${multipleExperts.length}]`)
        })
      }

      this.props.growlStore.showSuccess('Updating schedule...')

      await submitSchedule({
        availabilities: schedule.availabilities,
        drafts: [],
        timeslots: schedule.timeslots,
        eplId: this.availabilityStore.epl.id,
        lockInterviewDuration: false,
        message: {
          subjectExpert: '',
          subjectClient: '',
          expertEmail: '',
          clientMail: ''
        }
      })

      // const { capiDetails } = this.props.projectStore
      const { projectSource } = this.props.project
      const MC_KINSEY_PARENT_ACCOUNT_ID = 32

      if (this.props.epl.project.parentAccountId === MC_KINSEY_PARENT_ACCOUNT_ID && projectSource === 'capi-mckinsey') {
        await this.capiSendExpertAvailabilities(schedule.availabilities)
      }

      await this.props.eplModel.get()
      this.handleClose()
      this.props.growlStore.showSuccess('Schedule Updated')
    } catch (error) {
      console.error(error)
      this.props.growlStore.showError(error, `Could not send data to calendar service`)
    }
  }

  returnToScheduleModal = () => {
    this.props.modalStore.show({
      type: 'SCHEDULE_CALENDAR_MODAL',
      props: {
        eplModel: this.props.eplModel,
        epl: this.props.epl,
        project: this.props.project,
        // projectStore: this.props.projectStore
      }
    })
  }

  onDeleteTimeslot = async () => {
    await this.props.modalStore.close()
    return this.props.modalStore.show({
      type: 'EPL_CANCELLATION_MODAL',
      props: {
        title: 'Remove Timeslot',
        eplModel: this.props.eplModel,
        hideButtons: true,
        forbidCancel: false
      }
    })
  }

  render() {
    const { modalStore } = this.props
    const epl = modalStore.props.epl

    // this prevents rendering errors before the components un-mounts
    if (!epl) return null
    return (
      <>
        <CloseIcon
          className='close-icon'
          onClick={() => {
            this.handleClose()
          }}
        />
        <div className='expert-profile schedule-calendar-modal'>
          {this.renderLoader()}
          <FasterScheduling
            availabilityStore={this.availabilityStore}
            sendToCalendarService={this.sendToCalendarService}
            eplModel={this.props.eplModel}
            handleClose={this.handleClose}
            growlStore={this.props.growlStore}
            // projectStore={this.props.projectStore}
            onShowZoomMeeting={this.showZoomMeetingModal}
            onSendInviteExpert={this.showInviteExpert}
            onSendInviteClient={this.showInviteClient}
            onDeleteTimeslot={this.onDeleteTimeslot}
            project={this.props.project}
            multipleExperts={this.props.multipleExperts}
            showAddExpert={this.props.showAddExpert}
            multiAction={this.props.multiAction}
            renderPhoneNumbers={this.renderPhoneNumbers}
          />
        </div>
      </>
    )
  }
}

ScheduleCalendarModal.defaultProps = {
  shouldCloseOnOverlayClick: false,
  hideButtons: true,
  showCloseIcon: false
}

ScheduleCalendarModal.propTypes = {
  modalStore: PropTypes.object,
  growlStore: PropTypes.object,
  userStore: PropTypes.object,
  staticData: PropTypes.object,
  epl: PropTypes.object,
  eplModel: PropTypes.object,
  project: PropTypes.object
}

export default inject(
  'eplStore',
  'growlStore',
  'staticData',
  'modalStore',
  'userStore',
  // 'projectStore'
)(observer(ScheduleCalendarModal))
